import { createContext, useContext } from 'react';

import type { ReimbursementOrigin } from '../routes';
import type { ReimbursementDraft } from '../types';

export type ReimbursementDraftContextValue = {
    offerRequestLeadUuid: string;
    origin: ReimbursementOrigin;
    draft: ReimbursementDraft;
    updateDraft: (patch: Partial<ReimbursementDraft>) => void;
};

export const ReimbursementDraftContext = createContext<ReimbursementDraftContextValue | undefined>(undefined);

export function useReimbursementDraft(): ReimbursementDraftContextValue {
    const value = useContext(ReimbursementDraftContext);
    if (!value) {
        throw new Error('useReimbursementDraft must be used inside a ReimbursementDraftProvider');
    }
    return value;
}
